import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./modalpago.css";
import { consumir_refacil_pse } from "../services/services";

const ModalPago = ({ isOpen, onClose, userId, valorPagar, accountId }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    dniNumber: ''
  });
  const [errors, setErrors] = useState({});

  const usuario = JSON.parse(localStorage.getItem("credenciales"));

  const validateField = (name, value) => {
    switch (name) {
      case 'email':
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Correo electrónico inválido';
      case 'phone':
        return /^\d{10}$/.test(value) ? '' : 'Teléfono debe tener 10 dígitos';
      case 'dniNumber':
        return /^\d{1,10}$/.test(value) ? '' : 'Identificación debe tener máximo 10 dígitos';
      case 'fullName':
        return value.trim().length > 0 ? '' : 'Nombre es requerido';
      default:
        return '';
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let finalValue = value;
    
    if (name === 'phone' || name === 'dniNumber') {
      finalValue = value.replace(/\D/g, '').slice(0, 10);
    }

    setFormData(prev => ({
      ...prev,
      [name]: finalValue
    }));

    setErrors(prev => ({
      ...prev,
      [name]: validateField(name, finalValue)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newErrors = {};
    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });

    if (Object.keys(newErrors).length === 0) {
      const dataSend = {
        product: {
          atributes: {
            valorPagar,
            account_move_id: accountId,
          },
        },
        phone: formData.phone,
        emailAddress: formData.email,
        fullName: formData.fullName,
        dniNumber: formData.dniNumber
      };

      consumir_refacil_pse(dataSend, usuario, (flag, res) => {
        console.log('Respuesta:', res);
        if (flag) {
          window.location.href = res.url_pago;
        } else {
          console.log('Error al realizar el pago:', res);
        }
      });
      onClose();
    } else {
      setErrors(newErrors);
    }
  };

  if (!isOpen) return null;

  const modalContent = (
    <div className="modal-pago-overlay" style={{ zIndex: 10001 }}>
      <div className="modal-pago-wrapper" onClick={e => e.stopPropagation()} style={{ zIndex: 10002 }}>
        <div className="modal-pago">
          <div className="modal-pago-dialog">
            <div className="modal-pago-content">
              <div className="modal-pago-header">
                <h5 className="modal-pago-title">Información de Pago</h5>
                <button
                  type="button"
                  className="modal-pago-close"
                  onClick={onClose}
                  style={{ zIndex: 10003, cursor: 'pointer', pointerEvents: 'auto' }}
                >
                  ×
                </button>
              </div>
              <div className="modal-pago-body">
                <form onSubmit={handleSubmit} className="modal-pago-form">
                  <div className="modal-pago-form-group">
                    <input
                      type="text"
                      className={`modal-pago-input ${errors.fullName ? 'is-invalid' : ''}`}
                      id="fullName"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      placeholder=" "
                    />
                    <label htmlFor="fullName" className="modal-pago-label" style={{ color: '#ffffff' }}>
                      Nombre Completo
                    </label>
                    {errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
                  </div>

                  <div className="modal-pago-form-group">
                    <input
                      type="email"
                      className={`modal-pago-input ${errors.email ? 'is-invalid' : ''}`}
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder=" "
                    />
                    <label htmlFor="email" className="modal-pago-label" style={{ color: '#ffffff' }}>
                      Correo Electrónico
                    </label>
                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                  </div>

                  <div className="modal-pago-form-group">
                    <input
                      type="tel"
                      className={`modal-pago-input ${errors.phone ? 'is-invalid' : ''}`}
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder=" "
                    />
                    <label htmlFor="phone" className="modal-pago-label" style={{ color: '#ffffff' }}>
                      Teléfono
                    </label>
                    {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                  </div>

                  <div className="modal-pago-form-group">
                    <input
                      type="text"
                      className={`modal-pago-input ${errors.dniNumber ? 'is-invalid' : ''}`}
                      id="dniNumber"
                      name="dniNumber"
                      value={formData.dniNumber}
                      onChange={handleInputChange}
                      placeholder=" "
                    />
                    <label htmlFor="dniNumber" className="modal-pago-label" style={{ color: '#ffffff' }}>
                      N° Identificación
                    </label>
                    {errors.dniNumber && <div className="invalid-feedback">{errors.dniNumber}</div>}
                  </div>

                  <div className="modal-pago-total">
                    <div className="modal-pago-total-content">
                      <span className="modal-pago-total-label">Valor a Pagar:</span>
                      <span className="modal-pago-total-value">${valorPagar.toFixed(2)}</span>
                    </div>
                  </div>

                  <div className="modal-pago-footer">
                    <button
                      type="button"
                      className="modal-pago-button modal-pago-button-secondary"
                      onClick={onClose}
                      style={{ zIndex: 10003, cursor: 'pointer', pointerEvents: 'auto' }}
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="modal-pago-button modal-pago-button-primary"
                      style={{ zIndex: 10003, cursor: 'pointer', pointerEvents: 'auto' }}
                    >
                      Confirmar Pago
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ModalPago;